<mat-card>
	<mat-card-title>The page you're looking for can't be found</mat-card-title>
	<mat-card-content>
		
		<!-- <img [src]="image"> -->

	</mat-card-content>
</mat-card>